import { MouseEvent } from 'react';

import { createTranslatedText, TranslatableText } from '@dreryk/react-common';
import { useHistoryPushWithBackAction } from '@dreryk/react-components';

import { StyledTimeSinceLastVisitLink, StyledTimeSinceLastVisitValue } from './TimeSinceLastVisit.styled';

type TimeSinceLastVisitValueProps = {
   readonly label: string;
   readonly visitPath?: string;
   readonly backActionLabel?: TranslatableText;
};

export const TimeSinceLastVisitValue = (props: TimeSinceLastVisitValueProps): JSX.Element => {
   const pushToVisit = useHistoryPushWithBackAction(true);
   const { visitPath } = props;

   if (visitPath === undefined) {
      return <StyledTimeSinceLastVisitValue>{props.label}</StyledTimeSinceLastVisitValue>;
   }

   const handleNavigateToVisit = (event: MouseEvent<HTMLAnchorElement>): void => {
      event.preventDefault();
      pushToVisit(visitPath, { label: props.backActionLabel });
   };

   return (
      <StyledTimeSinceLastVisitLink
         testId={'lastVisitLink'}
         href={visitPath}
         label={createTranslatedText(props.label)}
         onClick={handleNavigateToVisit}
      />
   );
};
